import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext'

interface Props {
  ownerUserId: string
  onMarkFound: () => Promise<void>
}

export function MarkLostFoundButton({ ownerUserId, onMarkFound }: Props) {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [confirming, setConfirming] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const canMark =
    Boolean(user) &&
    (user!.id === ownerUserId || user!.moderator || user!.admin)

  if (!canMark) return null

  async function handleConfirm() {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      await onMarkFound()
    } catch (caught) {
      setError(
        caught instanceof Error && caught.message
          ? caught.message
          : t('lost.markFoundFailed'),
      )
      setBusy(false)
      setConfirming(false)
    }
  }

  return (
    <div className="lost-found-actions">
      {!confirming ? (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setConfirming(true)}
        >
          {t('lost.markFound')}
        </button>
      ) : (
        <div className="lost-found-confirm">
          <p className="field-help">{t('lost.markFoundConfirm')}</p>
          {error && (
            <p className="field-error" role="alert">
              {error}
            </p>
          )}
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => {
                setConfirming(false)
                setError(null)
              }}
              disabled={busy}
            >
              {t('actions.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => void handleConfirm()}
              disabled={busy}
            >
              {busy ? t('lost.markingFound') : t('lost.confirmMarkFound')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
